
const track=document.getElementById('heroTrack');
const slides=track ? track.children.length : 0;
const dots=document.querySelectorAll('.hero-nav .dot');
let cur=0,timer;
/* Not called render(): this file loads on every page, after the product page's
   script, and a global render() here replaced the buy box's — Buy 1/3/5, the
   price on Add to cart and the plan toggle all stopped redrawing. */
function heroRender(){
  if(!track) return;
  track.style.transform=`translateX(-${cur*100}%)`;
  dots.forEach((d,i)=>d.classList.toggle('on',i===cur));
}
function goSlide(i){cur=(i+slides)%slides;heroRender();restart()}
function moveSlide(d){goSlide(cur+d)}
function restart(){clearInterval(timer);timer=setInterval(()=>goSlide(cur+1),6000)}
if(track && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){restart()}

let sx=null;
if(track){
  track.addEventListener('touchstart',e=>{sx=e.touches[0].clientX},{passive:true});
  track.addEventListener('touchend',e=>{
    if(sx===null)return;
    const dx=e.changedTouches[0].clientX-sx;
    if(Math.abs(dx)>48)moveSlide(dx<0?1:-1);
    sx=null;
  },{passive:true});
}

const sticker=document.getElementById('dealSticker'),stickerX=document.getElementById('dealClose');
if(sticker && stickerX){
  stickerX.addEventListener('click',()=>{
    sticker.style.display='none';
    stickerX.style.display='none';
  });
}

// Only the hero guarantees clear space at bottom-left. Below it the sticker would
// sit on top of section copy and CTAs, so retire it once the hero scrolls away.
const heroEl=document.getElementById('hero');
let stickerCut=1e9;
function measureSticker(){ if(heroEl) stickerCut=heroEl.offsetTop+heroEl.offsetHeight-140; }
function syncSticker(){
  if(!sticker || !stickerX) return;
  const past=window.scrollY>stickerCut;
  sticker.classList.toggle('gone',past);
  stickerX.classList.toggle('gone',past);
}
if(heroEl){
  measureSticker();
  syncSticker();
  window.addEventListener('scroll',syncSticker,{passive:true});
  window.addEventListener('resize',()=>{measureSticker();syncSticker()},{passive:true});
  window.addEventListener('load',()=>{measureSticker();syncSticker()});
}
